import { Link } from "react-router-dom";
import { NAV } from "@/constants/testIds";
import { FAMILY_PORTAL_URL } from "@/lib/links";

const LOGO_URL = "/bookshelf-logo.png";

export default function SiteFooter() {
  return (
    <footer className="border-t border-stone-200/70 bg-[#F4EFE6]/60 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <span className="block h-10 w-10 rounded-lg bg-white overflow-hidden ring-1 ring-stone-200 p-1">
              <img src={LOGO_URL} alt="The Bookshelf Project, Inc." className="h-full w-full object-contain" />
            </span>
            <span className="font-serif text-base font-semibold text-[#122036]">The Bookshelf Project, Inc.</span>
          </div>
          <p className="text-sm text-stone-600 leading-relaxed max-w-xs">
            Building home libraries for families across the DMV — one bookshelf, one neighborhood at a time.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.18em] font-semibold text-stone-500 mb-3">Get involved</h4>
          <ul className="space-y-2 text-sm text-stone-700">
            <li>
              <a href={FAMILY_PORTAL_URL} target="_blank" rel="noreferrer" className="hover:text-[#122036]">
                Request a library
              </a>
            </li>
            <li><a href="https://thebookshelfproject.org" className="hover:text-[#122036]" target="_blank" rel="noreferrer">Donate books</a></li>
            <li><a href="https://thebookshelfproject.org" className="hover:text-[#122036]" target="_blank" rel="noreferrer">Volunteer</a></li>
            <li>
              <Link
                to="/admin/login"
                data-testid={NAV.adminLink}
                className="hover:text-[#122036]"
              >
                Admin sign-in
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.18em] font-semibold text-stone-500 mb-3">Service area</h4>
          <p className="text-sm text-stone-700 leading-relaxed">
            Washington D.C. · Prince George's & Montgomery County, MD · Arlington, Alexandria & Fairfax, VA
          </p>
        </div>
      </div>
      <div className="border-t border-stone-200/70 py-5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-xs text-stone-500 flex justify-between flex-wrap gap-2">
          <span>© {new Date().getFullYear()} The Bookshelf Project, Inc.</span>
          <span>Family pins are randomly offset to protect privacy.</span>
        </div>
      </div>
    </footer>
  );
}
